import store from "features/store";
import { Component } from "react";
import authService from "shared/services/authService";
import Validators from "shared/validators";
import { Button, Form, Modal, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "shared/settings/token";
import { loginWithRes } from "shared/settings/auth";
import { connect } from "react-redux";
import { socialAuthCredential } from "shared/settings/socialMediaConfig";
import GoogleLogin from "react-google-login";
import { LoginSocialFacebook } from "reactjs-social-login";
import AppleSignin from 'react-apple-signin-auth';
import { appleRegister, facebookRegister, googleRegister } from "shared/images/images";
import './Signin.scss';
import { showAndHideJiraButton } from "shared/jira-button";
import { mobileNumberFormat } from "shared/modifiers";
import { ManipulateTextHOC } from "shared/hoc/ManipulateTextHOC";
import { isAuthorized } from "shared/settings/auth";

export class ScmSignin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            innerWidth: window.innerWidth,
            phoneNumberDisabled: false,
            mobileModal: false,
            isOtpSent: false,
            mobile: {
                otp: { value: '', error: '', valid: false },
                valid: false
            },
            resendOtp: false,
            otpMessage: '',
            otpSuccess: false,
            isVerified: false,
            getOtpType: '',
            loaderHandle: '',
            phoneBtnDisable: false,
            profileBtnDisable: false,
            scmValidateModal: { show: false, type: '' },
            profileUpdateForm: {
                email: { value: '', error: '', valid: true },
                firstname: { value: '', error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, "First Name")], valid: true },
                lastname: { value: '', error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, "Last Name")], valid: true },
            },
            profileUpdateFormValid: false,
            scmPhoneNumber: "",
            appleIdLinkedMessage: '',
            appleLinkRemoval: { message: '', data: '', showSteps: false },
            scmTokenData: {},
            scmMedia: '',
            emailRestrictionMessage: '',
            mobileValidateErrorMsg: '',
            apiLoading: false
        };
        this.mobileDebounceTimeout = null;
        this.timeoutInterval = null;
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({
            ...this.state,
            innerWidth: window.innerWidth
        });
    }

    /** Called after sing complete in Google */
    responseGoogle = async (response) => {
        const data = {
            user: {},
            token: response.tokenObj.id_token
        };
        this.setState({
            scmTokenData: data,
            scmMedia: "google"
        }, () => {
            this.scmValidate();
        })
    };

    /** Called after sing complete in Facebook */
    responseFacebook = async (response) => {
        if (response.status !== 'unknown') {
            const data = {
                user: {}, 
                token: response.data.accessToken
            };
            this.setState({
                scmTokenData: data,
                scmMedia: "facebook"
            }, () => {
                this.scmValidate();
            })
        }
    };

    /** Called after sign complete in Apple */
    responseApple = async (response) => {
        this.setState({
            proxyEmail: false
        }, () => {
            this.appleSignHandle(response);
        });
    };

    appleSignHandle = (response) => {
        if (!this.state.proxyEmail) {
            const data = {
                user: {},
                token: response['authorization']['id_token']
            };

            if (response.hasOwnProperty('user')) {
                data['user']['email'] = response['user']['email'];
                data['user']['firstname'] = response['user']['name']['firstName'];
                data['user']['lastname'] = response['user']['name']['lastName'];
            }
            this.setState({
                scmTokenData: data,
                scmMedia: "apple"
            }, () => {
                this.scmValidate();
            })
        }
    }

    handleJiraButton = (flag, forceUpdate = false) => {
        if (forceUpdate) {
            showAndHideJiraButton(flag);
        }
    }

    scmValidate = (type) => {
        this.setState({
            apiLoading: true
        })
        let data = this.state.scmTokenData;

        if (this.state.profileUpdateForm.firstname.value && this.state.profileUpdateForm.lastname.value && this.state.profileUpdateForm.email.value) {
            data.user.firstname = this.state.profileUpdateForm.firstname.value;
            data.user.lastname = this.state.profileUpdateForm.lastname.value;
            data.user.email = this.state.profileUpdateForm.email.value;
        }

        if (this.state.scmPhoneNumber) {
            data.user.mobile = this.state.scmPhoneNumber.replace(/\D/g, '');
        }

        if (type === "linkscmaccount") {
            data['linkscmaccount'] = true;
        }

        if (this.state.scmMedia === "google") {
            authService.googleAuth({data: data}).then(
                response => {
                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, { props: this.props }).then((response) => {
                        this.handleJiraButton(false, true);
                        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                        this.setState({
                            apiLoading: false
                        })
                        this.props.history.push('/')
                    });
                }
            ).catch(error => {
                this.scmValidateError(error);
            });
        } else if (this.state.scmMedia === "facebook") {
            authService.facebookAuth({data: data}).then(
                response => {
                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, { props: this.props }).then((response) => {
                        this.handleJiraButton(false, true);
                        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                        this.setState({
                            apiLoading: false
                        })
                        this.props.history.push('/')
                    });
                }
            ).catch(error => {
                this.scmValidateError(error);
            });
        } else if (this.state.scmMedia === "apple") {
            authService.appleAuth({data: data}).then(
                response => {
                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, { props: this.props }).then((response) => {
                        this.handleJiraButton(false, true);
                        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                        this.setState({
                            apiLoading: false
                        })
                        this.props.history.push('/')
                    });
                }
            ).catch(error => {
                this.scmValidateError(error);
            });
        }
    }

    scmValidateError = (error) => {
        this.setState({
            apiLoading: false
        })
        if (error.ctbidserrorcode === "CBSC001") {
            this.setState({
                scmValidateModal: { show: true, type: "emailRestriction" },
                emailRestrictionMessage: error.message
            })
        } else if (error.ctbidserrorcode === "CBSCM002") {
            this.setState({
                scmValidateModal: { show: true, type: "profileUpdateModal" },
                    profileUpdateForm: {
                        ...this.state.profileUpdateForm,
                        email: { ...this.state.profileUpdateForm.email, value: error.data.email.value, valid: true },
                        firstname: { ...this.state.profileUpdateForm.firstname, value: error.data.firstname.value, error: error.data.firstname.error, valid: !error.data.firstname.value },
                        lastname: { ...this.state.profileUpdateForm.lastname, value: error.data.lastname.value, error: error.data.lastname.error, valid: !error.data.lastname.value }
                    }
            })
        } else if (error.ctbidserrorcode === "CBSCM003") {
            this.setState({
                scmValidateModal: { show: true, type: "phoneNumberModal" },
            })
        } else if (error.ctbidserrorcode === "CBSCM004") {
            this.setState({
                scmValidateModal: { show: true, type: "scmExistModal" },
            })
        } else if (error.ctbidserrorcode === "CBSCM005") {
            this.setState({
                scmValidateModal: { show: true, type: "appleLinkModal" },
                appleIdLinkedMessage: error.message
            })
        } else if (error.ctbidserrorcode === "CBSCM006") {
            this.setState({
                scmValidateModal: { show: true, type: "appleLinkRemoveModal" },
                appleLinkRemoval: {
                    ...this.state.appleLinkRemoval,
                    message: error.message,
                    data: error.data,
                    showSteps: false
                }
            });
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
            store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: error.message ? error.message : "Something went wrong" } });
        }
    }

    scmMobileNumber = (event) => {
        let phoneValue = event.target.value.replace(/\D/g, '');
        const eventValue = phoneValue ? mobileNumberFormat(event.target.value, this.state.scmPhoneNumber) : '';
        event.target.value = eventValue ? eventValue : phoneValue;

        this.setState({
            scmPhoneNumber: event.target.value,
            mobileValidateErrorMsg: '',
            phoneBtnDisable: true
        }, () => {
            if (this.mobileDebounceTimeout) {
                clearTimeout(this.mobileDebounceTimeout);
            }
            this.mobileDebounceTimeout = setTimeout(() => {
                let value = this.state.scmPhoneNumber.replace(/\D/g, '');
                if ( value.length == 10 ) {
                    const data = {
                        "data": {
                            "mobile": value,
                            "module": "scm"
                        }
                    };
                    authService.checkDetails(data).then(res => {
                        const result = res.data.data;
                        if (result.valid) {
                            this.setState({
                                mobileValidateErrorMsg: '',
                                phoneBtnDisable: false
                            })
                        }
                    }).catch(error => {
                        this.setState({
                            mobileValidateErrorMsg: error.message,
                            phoneBtnDisable: false
                        })
                    });
                }
            }, 500);
        })
    }

    validateName = (value) => {
        const alphabeticPattern = /^[a-zA-Z\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
       
            if(/\d/.test(value)) {
                return "This field only supports alphabetical characters.";
            } else if (/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\\/;’]/.test(value)) {
                return "This field only supports alphabetical characters."
            } else if (/^\s+|\s+$/.test(value)) {
                return "Please delete any added spaces before or after your entry";
            }
            else  if (alphabeticPattern.test(value)) {
                return ""; 
            } else {
                return "Please enter a valid character";
            }
                   
    };

    onScmInputValidation = (event, type) => {
        let controlError = '';
        let inputValue = event.target.value;

        /* checks all the validators for the control */
        for (let validator of this.state.profileUpdateForm[event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        if (event.target.name === 'firstname' || event.target.name === 'lastname') {
            const alphabeticPatternError = this.validateName(inputValue);
            if (alphabeticPatternError) {
                controlError = alphabeticPatternError;
            }
        }

        /* sets the state of the control and form validity */
        this.setState({
            profileUpdateForm: {
                ...this.state.profileUpdateForm,
                [type]: {
                    ...this.state.profileUpdateForm[type],
                    value: event.target.value,
                    error: controlError,
                    valid: !Boolean(controlError)
                }
            },
        }, () => {
            /* check form validity */
            if (controlError)
                this.setState({ profileUpdateFormValid: false });
            else {
                let profileUpdateFormValid = true;
                for (let control of Object.keys(this.state.profileUpdateForm)) {
                    if (!this.state.profileUpdateForm[control].valid) {
                        profileUpdateFormValid = false;
                        break;
                    }
                }
                this.setState({ profileUpdateFormValid: profileUpdateFormValid, profileBtnDisable: true }, () => {
                    if(event.target.name === "firstname" || event.target.name === "lastname"){
                        if (this.timeoutInterval) {
                            clearTimeout(this.timeoutInterval);
                        }
                        this.timeoutInterval = setTimeout(() =>  {
                            const data = {
                                data: {
                                    [event.target.name]: event.target.value
                                }
                            };
                            this.checkDetails(data, event.target.name);
                        }, 1000);
                    }
                });
            }
        });
    }

    checkDetails = (data, name) => {
        this.setState({
            apiLoading: true,
            profileBtnDisable: false
        });
        authService.checkDetails(data).then(res => {
            this.setState({
                apiLoading: false
            });
        }).catch(error => {
            this.setState({
                apiLoading: false
            });
            if(name === "firstname" || name === "lastname"){
                if(error.ctbidserrorcode == "CBBY014" ||  error.ctbidserrorcode == "CBBY016" ){
                    this.setState({
                        ...this.state,
                        profileUpdateForm: {
                            ...this.state.profileUpdateForm,
                            [name]: {
                                ...this.state.profileUpdateForm[name],
                                valid: !Boolean(error.message),
                                error: error.message
                            }
                        }
                    }, () => {
                        if (this.state.profileUpdateForm.email.valid && this.state.profileUpdateForm.firstname.valid && this.state.profileUpdateForm.lastname.valid) {
                            this.setState({
                                profileUpdateFormValid: true
                            });
                        } else {
                            this.setState({
                                profileUpdateFormValid: false
                            });
                        }
                    })
                } 
            }
        });
        }

    /* otp generated when mobile number changed */
    generateOtp = (flag) => {
        let value = this.state.scmPhoneNumber.replace(/\D/g, '');;
        this.setState({
            phoneBtnDisable: true,
            loaderHandle:flag,
            getOtpType: flag
        }, () => {
            const data = {
                "data": {
                    "mobile": value,
                    "otpvia": flag,
                }
            };
            authService.verifyMobileOtp(data).then(res => {
                this.setState({
                    isOtpSent: true,
                    otpMessage: '',
                    loaderHandle: '',
                    phoneBtnDisable: false
                });

            }).catch(error => {
                this.setState({
                    otpMessage: error.message,
                    loaderHandle: '',
                    phoneBtnDisable: false
                })
            })
        });
    }

    submitOtp = () => {
        let value = this.state.scmPhoneNumber.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value,
                "token": this.state.mobile.otp.value,
            }
        };
        authService.checkOtpVerify(data).then(res => {
            this.setState({
                otpMessage: 'Otp Verified',
                otpSuccess: true,
            });

            setTimeout(() => {
                this.setState({
                    ...this.state,
                    phoneNumberDisabled: true,
                    otpMessage: '',
                    isOtpSent: false,
                    otpSuccess: false,
                    isVerified: true,
                    mobile: {
                        ...this.state.mobile,
                        otp: {
                            ...this.state.mobile.otp,
                            value: ''
                        }
                    }
                })
            }, 2000);
            this.scmValidate("phonenumber");
        }).catch(error => {
            this.setState({
                otpMessage: error.message,
                otpSuccess: false
            })
        })
    }

    resendOtpfn = () => {
        this.setState({
            resendOtp: true,
        })
        let value = this.state.scmPhoneNumber.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value,
                "otpvia": this.state.getOtpType,
            }
        };
        authService.resendOtp(data).then(res => {
            this.setState({
                otpSuccess: true,
                otpMessage: 'Resend OTP Successfully',
                resendOtp: false,
            })
            setTimeout(() => {
                this.setState({
                    otpMessage: '',
                    resendOtp: false,
                })
            }, 1000);
        }).catch(error => {
            this.setState({
                otpSuccess: false,
                otpMessage: error.message,
                resendOtp: false,
            })
        })
    }

    onMobileChange = (event) => {
        let value = event.target.value.replace(/\D/g, '');
        this.setState({
            mobile: {
                ...this.state.mobile,
                otp: {
                    ...this.state.mobile.otp,
                    value: value
                }
            }
        });
    };

    cancelProfileAddress = () => {
        this.setState({
            scmValidateModal: { show: false, type: '' },
            profileUpdateForm: {
                ...this.state.profileUpdateForm,
                email: { ...this.state.profileUpdateForm.email, value: '' },
                firstname: { ...this.state.profileUpdateForm.firstname, value: '', error: '' },
                lastname: { ...this.state.profileUpdateForm.lastname, value: '', error: '' }
            },
            profileUpdateFormValid: false
        })
    }

    hideMobileModal = () => {
        this.setState({
            ...this.state,
            isOtpSent: false,
            otpMessage: '',
            otpSuccess: false,
            mobile: {
                ...this.state.mobile,
                otp: {
                    ...this.state.mobile.otp,
                    value: ''
                }
            },
            scmValidateModal: { show: false, type: '' },
            emailRestrictionMessage: '',
            appleIdLinkedMessage: '',
            mobileValidateErrorMsg: '',
            profileUpdateForm: {
                ...this.state.profileUpdateForm,
                email: { ...this.state.profileUpdateForm.email, value: '' },
                firstname: { ...this.state.profileUpdateForm.firstname, value: '', error: '' },
                lastname: { ...this.state.profileUpdateForm.lastname, value: '', error: '' }
            },
            profileUpdateFormValid: false,
            scmPhoneNumber: ''
        });
    }

    handleClose = () => {
        this.setState({
            scmValidateModal: { show: false, type: '' },
            emailRestrictionMessage: '',
            appleIdLinkedMessage: '',
            mobileValidateErrorMsg: '',
            scmPhoneNumber: ''
        })
    }

    render() {
        return (
            <div>
                <div className="mb-3">

                    {
                        this.state.proxyEmail ?
                            <div className="api-error">
                                Please enable share email
                            </div> : null
                    }
                    <div className="or-container">
                        <div className="line"></div>
                        <div>OR</div>
                        <div className="line"></div>
                    </div>

                    <div className="media-link">

                            <LoginSocialFacebook
                                appId={socialAuthCredential.facebook.appId}
                                onResolve={this.responseFacebook}
                                onReject={(err) => console.error("Facebook login failed:", err)}
                            >
                                <div className="social-media-container clickable">
                                    <div className="scm-section">
                                        <img src={facebookRegister} className="clickable" alt="FacebookLogin" style={{ width: '13px' }} />
                                        <span className="fs-18">Continue with Facebook</span>
                                    </div>
                                </div>
                            </LoginSocialFacebook>

                       
                        <GoogleLogin
                            clientId={socialAuthCredential.google.clientId}
                            render={renderProps => (
                                <div
                                    className="social-media-container clickable"
                                    onClick={renderProps.onClick} // Now applied to outer container
                                >
                                    <div className="scm-section" style={{marginRight: '19px'}}>
                                        <img
                                            src={googleRegister}
                                            className="clickable"
                                            alt="GoogleLogin"
                                            style={{ width: '16px' }}
                                        />
                                        <span className="fs-18">Continue with Google</span>
                                    </div>
                                </div>
                            )}
                            onSuccess={this.responseGoogle}
                            onRequest={this.onRequest}
                            cookiePolicy={'single_host_origin'}
                        />

                        <AppleSignin
                            authOptions={{
                                clientId: `${socialAuthCredential.apple.clientId}`,
                                scope: 'email name',
                                redirectURI: `${socialAuthCredential.apple.redirectURI}`,
                                usePopup: true,
                            }}
                            uiType="light"
                            onSuccess={this.responseApple}
                            render={renderProps => (
                                <div
                                    className="social-media-container clickable"
                                    onClick={renderProps.onClick}
                                >
                                    <div className="scm-section" style={{marginRight: '24px'}}>
                                        <img
                                            src={appleRegister}
                                            className="clickable"
                                            alt="AppleSignIn"
                                            style={{ width: '16px' }}
                                        />
                                        <span className="fs-18">Continue with Apple</span>
                                    </div>
                                </div>
                            )}
                        />

                    </div>
                </div>

                { /* Modal to validate scm */}
                <Modal centered show={this.state.scmValidateModal.show} className="change-mobile-modal" size={this.state.scmValidateModal.type === "profileUpdateModal" || this.state.scmValidateModal.type === 'appleLinkRemoveModal' ? "lg" : "md"} onHide={ this.hideMobileModal }>
                    <Modal.Body>
                        <div className="profile-modal-close-icon clickable" onClick={this.hideMobileModal}></div>

                        {
                            this.state.scmValidateModal.type === "phoneNumberModal" ?
                                <div className="d-flex flex-column justify-content-center align-items-center w-100">
                                    <div className="text-center text-bold mt-4">Verify your phone number for your CTBids Account</div>
                                    <div className=" mt-3 mb-3" style={{ width: "90%" }}>

                                        <Form.Group>
                                            <Form.Label className="required">Phone Number</Form.Label>
                                            <Form.Control autoFocus type="text" id="newMobile" pattern="^\d+$" name="newMobile" value={this.state.scmPhoneNumber} onChange={(event) => this.scmMobileNumber(event)} />

                                        </Form.Group>

                                    </div>
                                    {this.state.isOtpSent &&
                                        <div className="" style={{ width: "90%" }}>
                                            <Form.Group>
                                                <Form.Label className="required text-bold">OTP
                                                    <sup>
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                <Tooltip id="otp-tooltip" className="custom-tooltip">
                                                                    OTP (One-Time Password) Verifies identity, authenticates email and ensures secure user creation
                                                                </Tooltip>
                                                            } >
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/static/icons/common-icons/info.svg`}
                                                                style={{ width: '12px', marginLeft: '3px', cursor: 'pointer' }}
                                                                alt="info-icon"
                                                            />
                                                        </OverlayTrigger>
                                                    </sup>
                                                </Form.Label>
                                                <Form.Control autoFocus type="text" pattern="^\d+$" id="otp" name="otp" maxLength={6} placeholder="Enter OTP" value={this.state.mobile.otp.value}
                                                    onChange={(event) => this.onMobileChange(event)} />
                                            </Form.Group>
                                        </div>
                                    }
                                    <div className="mt-2">
                                        <div className={`${this.state.otpSuccess ? 'text-success' : 'text-danger'} text-center m-3`}>
                                            {
                                                this.state.otpMessage ? <div >{this.state.otpMessage}</div> : null
                                            }
                                        </div>

                                        {
                                            this.state.isOtpSent ?
                                                <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                                                    <Button variant="secondary" disabled={this.state.mobile.otp.value == ''} onClick={() => { this.submitOtp() }}>
                                                        Verify
                                                    </Button>
                                                </div> :
                                                <div className="d-flex justify-content-center align-items-center">
                                                    <Button variant="outline-dark btn-white mx-2" onClick={() => { this.generateOtp('call') }} disabled={this.state.phoneBtnDisable || this.state.mobileValidateErrorMsg || this.state.scmPhoneNumber.replace(/\D/g, '').length != 10}>
                                                        Call me {
                                                            this.state.loaderHandle === 'call' ?
                                                                <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                                null
                                                        }
                                                    </Button>
                                                    <Button variant="secondary" onClick={() => { this.generateOtp('sms') }} disabled={this.state.phoneBtnDisable || this.state.mobileValidateErrorMsg || this.state.scmPhoneNumber.replace(/\D/g, '').length != 10}>
                                                        Text me  {
                                                            this.state.loaderHandle === 'sms' ?
                                                                <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                                null
                                                        }
                                                    </Button>
                                                </div>
                                        }
                                        {
                                            this.state.mobileValidateErrorMsg ? <div className="text-danger text-center m-3">{this.state.mobileValidateErrorMsg}</div> : null
                                        }
                                        {
                                            this.state.isOtpSent ? <div className="mt-2 text-center">
                                                Not received? <span className="change-email-link clickable" onClick={() => this.resendOtpfn()} disabled={this.state.otpMessage}>
                                                    Resend {
                                                        this.state.resendOtp ?
                                                            <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                            null
                                                    }
                                                </span>
                                            </div> : null
                                        }
                                    </div>
                                </div> : this.state.scmValidateModal.type === "profileUpdateModal" ?
                                    <Form className="profile-modal">
                                        <div className="row-handle d-lg-flex">
                                            <div className="col-handle-2" style={{ marginRight: "15px" }}>
                                                <div className="float-control lg" style={{ opacity: "1 !important" }}>
                                                    <Form.Control size="lg" type="text" id="email" name="email" placeholder=" " value={this.state.profileUpdateForm.email.value} disabled />
                                                    <Form.Label htmlFor="email" className="required">Email</Form.Label>
                                                    <div className="text scm-text">
                                                        {
                                                            this.state.profileUpdateForm.email.error ? <small className="text-danger">{this.state.profileUpdateForm.email.error}</small> : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row-handle d-lg-flex" style={{gap: '1rem'}}>
                                            <div className="col-handle-2 w-100">
                                                <div className="float-control lg">
                                                    <Form.Control size="lg" type="text" id="firstname" name="firstname" placeholder=" " value={this.state.profileUpdateForm.firstname.value} onChange={(e) => { this.onScmInputValidation(e, "firstname") }} />
                                                    <Form.Label htmlFor="firstname" className="required">First Name</Form.Label>
                                                    <div className="text scm-text">
                                                        {
                                                            this.state.profileUpdateForm.firstname.error ? <small className="text-danger">{this.state.profileUpdateForm.firstname.error}</small> : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-handle-2 w-100">
                                                <div className="float-control lg">
                                                    <Form.Control size="lg" type="text" id="lastname" name="lastname" placeholder=" " value={this.state.profileUpdateForm.lastname.value} onChange={(e) => { this.onScmInputValidation(e, "lastname") }} />
                                                    <Form.Label htmlFor="lastname" className="required">Last Name</Form.Label>
                                                    <div className="text scm-text">
                                                        {
                                                            this.state.profileUpdateForm.lastname.error ? <small className="text-danger">{this.state.profileUpdateForm.lastname.error}</small> : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="buttons d-flex mt-5" style={{ justifyContent: "center" }}>
                                            <Button variant="outline-primary" style={{ width: "25%" }} onClick={this.cancelProfileAddress}>Cancel</Button>
                                            <Button variant="secondary ml-10" style={{ width: "25%" }} onClick={() => { this.scmValidate("profileupdate") }} disabled={!this.state.profileUpdateFormValid || this.state.profileBtnDisable || this.state.apiLoading}>
                                                Save {' '} {this.state.apiLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> : null}
                                            </Button>
                                        </div>
                                    </Form> : this.state.scmValidateModal.type === "scmExistModal" ?
                                        <div className="content-container">
                                            <div className="text-center my-2">
                                                This email already exists. Do you want link with that account.
                                            </div>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <Button variant="outline-dark btn-white mx-2" onClick={this.handleClose}>No</Button>
                                                <Button variant="secondary mx-2" disabled={this.state.loader} onClick={() => { this.scmValidate("linkscmaccount") }}>Yes {' '} {this.state.loader ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> : null}</Button>
                                            </div>
                                        </div> : this.state.scmValidateModal.type === "appleLinkModal" ?
                                        <div className='d-flex align-items-center justify-content-center flex-column'>
                                            <div>{this.state.appleIdLinkedMessage}</div>
                                            <Button variant="secondary w-20 mt-3" onClick={() => {this.handleClose()}}>Ok</Button>
                                        </div> : this.state.scmValidateModal.type === "emailRestriction" ?
                                        <div className='d-flex align-items-center justify-content-center flex-column'>
                                            <div>{this.state.emailRestrictionMessage}</div>
                                            <Button variant="secondary w-20 mt-3" onClick={() => {this.handleClose()}}>Ok</Button>
                                        </div> : this.state.scmValidateModal.type === 'appleLinkRemoveModal' ? 
                                        <div className="apple-link-removal">
                                            <ManipulateTextHOC text={this.state.appleLinkRemoval.message} onClickCallback={() => { 
                                                    this.setState({
                                                        appleLinkRemoval: {
                                                            ...this.state.appleLinkRemoval,
                                                            showSteps: true
                                                        }
                                                    }); 
                                                }}
                                            />
                                            {
                                                this.state.appleLinkRemoval.showSteps ? 
                                                <div style={{paddingTop: "1rem"}} dangerouslySetInnerHTML={{__html: this.state.appleLinkRemoval.data}}></div> : ''
                                            }
                                        </div> : ''
                        }
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default connect(state => state)(ScmSignin);